var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgeMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    role: "img",
    "aria-label": "Forge Media",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "forgeMarkGradient",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B9A7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6E5BD6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#forgeMarkGradient)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 30 L92 6 L74 34 L6 52 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 56 L72 40 L56 66 L10 78 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 30 L6 94 Q24 96 30 80 L30 36 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgeMark);
export default __webpack_public_path__ + "static/media/forge-mark.83b198ecd56654fe1b6eee14324d3863.svg";
export { ForwardRef as ReactComponent };